import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import { createStyles, makeStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { Annotation } from "../../../types";

interface Props {
  open: boolean;
  annotation: Annotation;
  handleClose: () => void;
  handleApprove: (annotation: Annotation) => void;
}

const dialogTitleStyles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof dialogTitleStyles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(dialogTitleStyles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes?.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes?.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

// Defined once at module scope (rather than calling makeStyles({...})() inline on every render)
// - the inline pattern creates a brand new style-sheet hook per render, which under React 18
// crashes on unmount with "Cannot read properties of undefined (reading 'refs')" in
// @material-ui/styles' detach cleanup.
const useStyles = makeStyles({
  dialog: {
    padding: "20px",
  },
  dialogContent: {
    textAlign: "center",
  },
});

const ApproveAnnotationDialog = (props: Props) => {
  const { handleClose, open, handleApprove, annotation } = props;

  const classes = useStyles();

  return (
    <Dialog className={classes.dialog} onClose={handleClose} aria-labelledby="approve-annotation-dialog-title" open={open} fullWidth>
      <DialogTitle id="approve-annotation-dialog-title" onClose={handleClose}>
        {annotation.approval_status == "pending" ? "Approve" : "Disapprove"} Annotation
      </DialogTitle>
      <DialogContent className={classes.dialogContent} dividers>
        <Typography gutterBottom>
          Are you sure you want to {annotation.approval_status == "pending" ? "approve" : "disapprove"} this annotation?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => handleApprove(annotation)} color="primary">
          Confirm {annotation.approval_status == "pending" ? "Approve" : "Disapprove"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveAnnotationDialog;
